import { useNavigate } from "react-router-dom";

import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Typography, Avatar, Dropdown, type MenuProps } from "antd";

import { getUser, deleteUserSession } from "../../../services/auth";
import useDeviceType from "../../../utils/deviceType";
import { capitalizeEachWord } from "../../../utils/stringUtils";

const { Text } = Typography;

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    alignItems: "center",
    border: "2px solid #DBDBDB",
    borderRadius: "8px",
    padding: "8px 12px",
    cursor: "pointer",
    maxHeight: "45px",
    gap: "12px",
    transition: "all 0.3s ease",
  },
  textContainer: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    flex: 1,
  },
  name: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  role: {
    fontSize: "0.85em",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  avatar: {
    flexShrink: 0,
  },
};

const UserProfile = () => {
  const { isMobile } = useDeviceType();
  const navigate = useNavigate();
  const user = getUser();

  const handleLogout = () => {
    deleteUserSession();
    navigate(0);
  };

  const menuItems: MenuProps["items"] = [
    {
      key: "profile",
      label: "Profile",
      icon: <UserOutlined />,
      onClick: () =>
        navigate(`/users/${user.id}`, {
          state: { userId: user.id, displayName: user.name },
        }),
    },
    {
      type: "divider",
    },
    {
      key: "logout",
      label: "Logout",
      icon: <LogoutOutlined />,
      onClick: handleLogout,
    },
  ];

  return isMobile ? (
    <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
      <Avatar icon={<UserOutlined />} style={styles.avatar} />
    </Dropdown>
  ) : (
    <Dropdown menu={{ items: menuItems }} trigger={["click"]}>
      <div style={styles.container}>
        <div style={styles.textContainer}>
          <Text strong style={styles.name}>
            {capitalizeEachWord(user.name)}
          </Text>
          <Text style={styles.role}>{capitalizeEachWord(user.role)}</Text>
        </div>
        <Avatar icon={<UserOutlined />} style={styles.avatar} />
      </div>
    </Dropdown>
  );
};

export default UserProfile;
